import * as React from 'react';

import { Wrapper } from '../Wrapper';

import * as styles from './styles.css';

export interface ICostEstimateProps {
  title: string;
  marketPrice: React.ReactElement | null;
  chart: React.ReactElement | null;
  calculatorLink: React.ReactElement | null;
}

export const CostEstimate: React.FC<ICostEstimateProps> = props => {
  return (
    <Wrapper>
      <h2 className={styles['title']}>{props.title}</h2>
      {props.marketPrice && <div className={styles['market-price']}>{props.marketPrice}</div>}
      <div className={styles['chart']}>{props.chart}</div>
      {props.calculatorLink && <div className={styles['button']}>{props.calculatorLink}</div>}
    </Wrapper>
  );
};

CostEstimate.displayName = 'CostEstimate';
